class Photo {
  constructor (data) {
    this.id = data ? data.id : ''
    this.name = data ? data.name : ''
    this.photo_no = data ? data.photo_no : ''
    this.upc = data ? data.upc : ''
    this.sort_no = data ? data.sort_no : 0
    // eslint-disable-next-line eqeqeq
    this.is_enabled = data ? (data.is_enabled == 1) : true
    this.thumbnail = data ? data.thumbnail : null
    this.thumbnailUrl = data ? data.thumbnailUrl : null
    this.keywords = data ? data.keywords : null
    this.downloads = data ? data.downloads : -1
  }

  getFormData () {
    let formData = new FormData()
    formData.append('id', this.id)
    formData.append('name', this.name)
    formData.append('photo_no', this.photo_no)
    formData.append('upc', this.upc)
    formData.append('sort_no', this.sort_no)
    formData.append('is_enabled', this.is_enabled === true)
    formData.append('thumbnail', this.thumbnail)
    formData.append('keywords', this.keywords)
    return formData
  }
}

export default Photo



// WEBPACK FOOTER //
// ./src/models/Photo.js